import { updateObjectState } from '../../helpers';

import * as Constants from '../constants';
import { INITIAL_DATA_STATE } from '../initial-state';

import { updateValueFieldsReducer } from './helpers';

const resetDataReducer = (state) => {
  return { ...state, [Constants.FIELDS.DATA]: INITIAL_DATA_STATE };
};

const updateDataFieldReducer = (state, payload) => {
  const result = Object.entries(payload).reduce(
    (acc, [name, payload]) => {
      return updateObjectState({
        name,
        payload: { ...Constants.DEFAULT_DATA_VALUE, ...payload },
        state: acc,
      });
    },
    { ...state[Constants.FIELDS.DATA] }
  );

  return updateObjectState({ name: Constants.FIELDS.DATA, payload: result, state });
};

export const DATA_REDUCERS = {
  [Constants.ACTIONS.RESET_DATA]: resetDataReducer,
  [Constants.ACTIONS.UPDATE_DATA_DISABLED]: updateValueFieldsReducer({
    storeField: Constants.FIELDS.DATA,
    valueField: Constants.DATA_VALUE_FIELDS.DISABLED,
  }),
  [Constants.ACTIONS.UPDATE_DATA_ERRORS]: updateValueFieldsReducer({
    storeField: Constants.FIELDS.DATA,
    valueField: Constants.DATA_VALUE_FIELDS.ERROR,
  }),
  [Constants.ACTIONS.UPDATE_DATA_FIELDS]: updateDataFieldReducer,
  [Constants.ACTIONS.UPDATE_DATA_HIDDEN]: updateValueFieldsReducer({
    storeField: Constants.FIELDS.DATA,
    valueField: Constants.DATA_VALUE_FIELDS.HIDDEN,
  }),
  [Constants.ACTIONS.UPDATE_DATA_VALUES]: updateValueFieldsReducer({
    storeField: Constants.FIELDS.DATA,
    valueField: Constants.DATA_VALUE_FIELDS.VALUE,
  }),
};
